$(document).ready(function () {

	if (window.innerWidth > 991) {
		$('#mainNav').superfish();
	}

	document.onkeydown = function (evt) {
		evt = evt || window.event;
		var isEscape = false;

		if ("key" in evt) {
			isEscape = (evt.key === "Escape" || evt.key === "Esc");
		} else {
			isEscape = (evt.keyCode === 27);
		}
		if (isEscape) {
			$('#mainNav').superfish('hide');
		}
	};

  	$(window).resize(function () {
		if (window.innerWidth > 991) {
			$('#mainNav').superfish();
		}
		else {
			$('#mainNav').superfish('destroy');
		}
	});

	$('.has-sub').on('click', function(e){
		if (window.innerWidth < 991) {
			e.preventDefault()
			$(this).parent().toggleClass('sfHover')
		}
	})

});
